

import {defineComponent} from 'vue';
import Icon from "@/components/common/icons/Icon.vue"
import Copy from "@/components/common/typography/Copy.vue";

export default defineComponent({
  name: 'Toast',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  components: {
    Copy,
    Icon
  },
  setup(props, context) {
    return () =>
      <div class={"toast"}>
        <div class="toast-content">
          <Icon name="Check"/>
          <Copy class="toast-text" type="Black">{props.text}</Copy>
        </div>
      </div>
  }
});
